import { useSearchParams } from "$root/utils";
import { useState } from "react";
import { useHistory } from "react-router";

export function useWorkspaceSearchParams() {
	const history = useHistory();
	const { preselectedInvestments } = useSearchParams();
	const [preselectedInvestmentsState] = useState(() => {
		if (!preselectedInvestments) {
			return undefined;
		}
		history.replace({
			...history.location,
			search: (() => {
				const parsed = new URLSearchParams(history.location.search);
				parsed.delete("preselectedInvestments");
				return parsed.toString();
			})(),
		});
		return preselectedInvestments.split("|");
	});
	return { preselectedInvestments: preselectedInvestmentsState };
}
